import { render, staticRenderFns } from "./popupRejectInfo.vue?vue&type=template&id=484c5aea"
import script from "./popupRejectInfo.vue?vue&type=script&lang=js"
export * from "./popupRejectInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports